import {IComponentOptions, IFilterService, ILogService} from 'angular';
import {rolePrefix, TSRole} from '../../../models/enums/TSRole';
import TSBenutzer from '../../../models/TSBenutzer';
import RoleUtilService from '../../service/RoleUtilService';
import {getTSSpracheValues, TSSprache} from '../../../models/enums/TSSprache';
import IScope = angular.IScope;
import IWindowService = angular.IWindowService;
import ITranslateService = angular.translate.ITranslateService;

let template = require('./dv-benutzer-list.html');
require('./dv-benutzer-list.scss');

export class DVBenutzerListComponentConfig implements IComponentOptions {
    transclude = false;

    bindings: any = {
        benutzerlist: '=',
        itemsByPage: '<',
        onEdit: '&',
        onDelete: '&',
        showRole: '<',
        showAnlaufstelleAndKanton: '<',
        showActions: '<',
        showFilter: '<'
    };
    template = template;
    controller = DVBenutzerListController;
    controllerAs = 'vm';
}

export class DVBenutzerListController {

    itemsByPage: number;
    benutzerlist: Array<TSBenutzer> = []; //Liste die im Gui angezeigt wird
    pagination: any;
    onEdit: (paramObj: any) => void;
    onDelete: (paramObj: any) => void;
    showRole: boolean;
    showFilter: boolean;
    showActions: boolean;
    selectedSprache: string;

    static $inject: any[] = ['$filter', '$log', 'CONSTANTS', '$scope', 'RoleUtilService', '$window', '$translate'];

    /* @ngInject */
    constructor(private $filter: IFilterService, private $log: ILogService,
                private CONSTANTS: any, private $scope: IScope, private roleUtilService: RoleUtilService,
                private $window: IWindowService, private $translate: ITranslateService) {
        this.initViewModel();
    }

    private initViewModel() {

    }

    $onInit() {
        if (this.showRole === undefined) {
            this.showRole = true;
        }

        if (this.showFilter === undefined) {
            this.showFilter = true;
        }
        if (this.showActions === undefined) {
            this.showActions = true;
        }

    }

    public getFilterroles(): Array<TSRole> {
        return this.roleUtilService.removeRoles(this.roleUtilService.getAllRolesWithNAButGesuchstellerArray(), [TSRole.FONDSSUISSE_ADMIN, TSRole.SUPER_ADMIN]);

    }

    editClicked(benutzerToEdit: any, event: any) {
        this.onEdit({benutzer: benutzerToEdit, event: event});
    }

    deleteClicked(benutzerToDelete: any, event: any) {
        this.onDelete({benutzer: benutzerToDelete, event: event})
    }

    public translateAktiv(inaktiv: boolean): string {
        if (inaktiv === undefined) {
            return '-';
        }
        return inaktiv ? (this.$translate.instant('INAKTIV')) : (this.$translate.instant('AKTIV'));

    }

    public translateSprache(sprache: TSSprache): string {
        if (sprache === undefined) {
            return '-';
        }
        return this.$translate.instant(TSSprache[sprache]);

    }

    public translateRoles(roles: Array<TSRole>): string {
        let prefix = rolePrefix();
        return roles.map((element) => {
            return this.$translate.instant(prefix + TSRole[element])
        }).join(', ');

    }

    public translateRole(role: TSRole): string {
        let prefix = rolePrefix();
        return this.$translate.instant(prefix + TSRole[role])

    }

    public getColumnsNumber(): number {

        let element = angular.element('.dv-benutzer-list .header-row').first();
        if (element) {
            return element.get(0).childElementCount;
        }
        //could not determine actual number, just returing an approximation
        return 12;
    }

    private getTSSpracheValues(): Array<TSSprache> {
        return getTSSpracheValues();
    }

}



// WEBPACK FOOTER //
// ./src/app/core/component/dv-benutzer-list/dv-benutzer-list.ts